// src/constants.ts
var COOKIE_NAME = "twCookieConsent";
var SIMPLE_COOKIE_NAME = "twCookieConsentGTM";
var COOKIE_POLICY_ID = "2023-10-16";
var DEFAULT_COOKIE_EXPIRY = 182 * 24 * 60 * 60 * 1e3;
var COOKIE_CONSENT_ACCEPT_EVENT_NAME = "accepttwcookieconsent";

export { COOKIE_CONSENT_ACCEPT_EVENT_NAME, COOKIE_NAME, COOKIE_POLICY_ID, DEFAULT_COOKIE_EXPIRY, SIMPLE_COOKIE_NAME };
//# sourceMappingURL=chunk-R6LOGD7N.mjs.map
//# sourceMappingURL=chunk-R6LOGD7N.mjs.map